<template>
  <div>
    <ul class="rew19_clear showPaymentType" v-show="!isHidden">
      <li class="rew19_wrapRadio_t1 rew19_lineup_left">
        <input
          id="paymentInfo_type_2"
          v-model.number="paymentType" value="2"
          @click="showTerms"
          class="rew19_fakeRadio_t1 dev-paytype-radio"
          type="radio"
          checked="checked"
          :disabled="paymentType === 2"
        />
        <label for="paymentInfo_type_2">신용카드</label>
      </li>

      <li v-show="mode != 'NTC'" class="rew19_wrapRadio_t1 rew19_lineup_left">
        <input
          id="paymentInfo_type_3"
          v-model.number="paymentType" value="3"
          @click="loadCms"
          class="rew19_fakeRadio_t1 dev-paytype-radio"
          type="radio"
          :disabled="paymentType === 3"
        />
        <label for="paymentInfo_type_3">계좌 자동이체</label>
      </li>
    </ul>

    <div v-show="paymentType == 2" :class="{'rew19_visible_card': paymentMode == 0}" class="rew19_visible_card rew19_visibleOp" style="display: block;">
      <ul class="rew19_form_flexble">
        <li class="rew19_form_table">
          <em class="rew19_form_tit">생년월일</em>
          <div class="rew19_form_full">
            <input
              v-model.trim="viewData.card.birth"  ref="birth"
              @keypress="numberKeyPress($event)"
              @keyup="keyUpToNumber($event, 'cardNum1')"
              title="카드소유주 주민등록상 생년월일 6자리 입력"
              type="tel"
              class="autoFocus onlynum rew19_inputTxt_t1"
              maxlength="6"
              placeholder="주민등록번호 앞 6자리"
            />
          </div>
        </li>
        <li class="rew19_form_table">
          <em class="rew19_form_tit">카드번호</em>
          <div class="rew19_form_cell rew19_form_wides">
            <span class="rew19_form_card adicon">
              <input
                v-model.trim="viewData.card.cardNums[0]" ref="cardNum1"
                @keypress="numberKeyPress($event)"
                @keyup="keyUpToNumber($event, 'cardNum2')"
                @keydown="keyDown($event, 0)"
                title="카드번호 입력"
                type="tel"
                maxlength="4"
                class="rew19_inputTxt_t1 rew19_aCenter autoFocus onlynum"
              />
            </span>
            <span class="rew19_form_card adicon">
              <input
                v-model.trim="viewData.card.cardNums[1]" ref="cardNum2"
                @keypress="numberKeyPress($event)"
                @keyup="keyUpToNumber($event, 'cardNum3')"
                @keydown="keyDown($event, 1)"
                type="password"
                title="카드번호 입력"
                maxlength="4"
                class="rew19_inputTxt_t1 rew19_aCenter autoFocus onlynum"
              />
            </span>
            <span class="rew19_form_card adicon">
              <input
                v-model.trim="viewData.card.cardNums[2]" ref="cardNum3"
                @keypress="numberKeyPress($event)"
                @keyup="keyUpToNumber($event, 'cardNum4')"
                @keydown="keyDown($event, 2)"
                type="password"
                title="카드번호 입력"
                maxlength="4"
                class="rew19_inputTxt_t1 rew19_aCenter autoFocus onlynum"
              />
            </span>
            <span class="rew19_form_card">
              <input
                v-model.trim="viewData.card.cardNums[3]" ref="cardNum4"
                @keypress="numberKeyPress($event)"
                @keyup="keyUpToNumber($event, 'expMM')"
                @keydown="keyDown($event, 3)"
                type="tel"
                title="카드번호 입력"
                maxlength="4"
                class="rew19_inputTxt_t1 rew19_aCenter autoFocus onlynum"
              />
            </span>
          </div>
          <p>
            <span class="rew19_infoStar">사용불가 카드&nbsp;: 외국계카드, 법인카드</span>
          </p>
        </li>
        <li class="rew19_form_table">
          <em class="rew19_form_tit">유효기간</em>
          <div class="rew19_form_cell rew19_form_wides">
            <span class="rew19_form_term adicon">
              <input
                v-model.trim="viewData.card.expMM" ref="expMM"
                @keypress="numberKeyPress($event)"
                @keyup="keyUpToNumber($event, 'expYY')"
                title="유효기간 입력" type="tel" maxlength="2"
                class="rew19_inputTxt_t1 rew19_aCenter autoFocus onlynum"
                placeholder="MM"
              />
            </span>
            <span class="rew19_form_term">
              <input
                v-model.trim="viewData.card.expYY" ref="expYY"
                @keypress="numberKeyPress($event)"
                @keyup="keyUpToNumber($event, 'pwd')"
                title="유효기간 입력" type="tel" maxlength="2"
                placeholder="YY"
                class="rew19_inputTxt_t1 rew19_aCenter autoFocus onlynum"
              />
            </span>
          </div>
        </li>
        <li class="rew19_form_table">
          <em class="rew19_form_tit">카드비밀번호</em>
          <div class="rew19_form_cell rew19_form_wides">
            <span class="rew19_form_term harf">
              <input
                v-model.trim="viewData.card.pwd" ref="pwd"
                @keypress="numberKeyPress($event)"
                @keyup="keyUpToNumber($event)"
                type="password"
                class="rew19_inputTxt_t1 rew19_aCenter autoFocus onlynum"
                title="카드 비밀번호 입력"
                maxlength="2"
              />
            </span>
            <span class="rew19_form_term">
              <span class="rew19_form_pass rew19_telTxt">** (앞자리 2자리)</span>
            </span>
          </div>
        </li>
        <li v-if="mode != 'NTC'" class="rew19_form_normal">
          <em class="rew19_form_tit">할부개월</em>
          <div class="rew19_form_full">
            <select
              v-model="viewData.card.instMonth"
              title="카드결제 할부개월"
              class="rew19_select_t1 sel_search1 autoFocus"
            >
              <option value="00">일시불</option>
              <option value="02">2개월</option>
              <option value="03">3개월</option>
              <option value="04">4개월</option>
              <option value="05">5개월</option>
              <option value="06">6개월</option>
              <option value="07">7개월</option>
              <option value="08">8개월</option>
              <option value="09">9개월</option>
              <option value="10">10개월</option>
              <option value="11">11개월</option>
              <option value="12">12개월</option>
            </select>
          </div>
          <p>
            <span class="rew19_infoStar">체크카드는 할부를 지원하지 않습니다.</span>
          </p>
        </li>
      </ul>
    </div>
    <!--rew19_visible_card-->

    <div v-show="paymentType==3" :class="{'rew19_visible_bBook': paymentMode ==0 }" class="rew19_visible_bBook rew19_visibleOp">

      <div v-show="!viewData.account.bank_account"
        class="rew19_order_box">
        <p>회원님은 자동이체 계좌가 등록되어 있지 않습니다</p>
        <span>
          자동이체 등록은 3일정도 소요되며, 등록완료 자동이체 이용이 가능합니다.<br/>
          (신용카드 결제의 경우 즉시 제품 주문이 가능합니다)<br/>
          자동이체 신청회원은 아래 '자동이체 변경 관리'버튼을 선택하세요
        </span>
      </div>

      <ul v-show="viewData.account.bank_account"
        class="rew19_form_flexble">
        <li class="rew19_form_table">
          <em class="rew19_form_tit">결제은행</em>
          <div class="rew19_txt_full">{{viewData.account.bank_name}}</div>
        </li>
        <li class="rew19_form_table">
          <em class="rew19_form_tit">계좌번호</em>
          <div class="rew19_txt_full">{{viewData.account.bank_account}}</div>
        </li>
        <li class="rew19_form_table">
          <em class="rew19_form_tit">예금주</em>
          <div class="rew19_txt_full">{{viewData.account.bank_account_holder}}</div>
        </li>
        <li class="rew19_form_table">
          <em class="rew19_form_tit">생년월일</em>
          <div class="rew19_form_full">
            <input
              v-model.trim="viewData.account.birth" ref="account.birth"
              @keypress="numberKeyPress($event)"
              @keyup="keyUpToNumber($event)"
              title="카드소유주 주민등록상 생년월일 6자리 입력"
              type="tel"
              class="autoFocus onlynum rew19_inputTxt_t1"
              maxlength="6"
              placeholder="주민등록번호 앞 6자리"
            />
          </div>
        </li>
        <li class="rew19_form_table">
            <em class="rew19_form_tit nextLine">현금영수증 발급<span>핸드폰 번호</span></em>
            <div class="rew19_form_full">
                <input
                v-model.trim="viewData.account.receipt_no" ref="account.receipt_no"
                title="현금영수증발급 핸드폰번호"
                type="tel"
                maxlength="13"
                class="autoFocus rew19_inputTxt_t1" placeholder="010-0000-0000">
            </div>
        </li>
      </ul>

      <dl class="rew19_bankInfo">
        <dt>
          <a @click="openBackAccountRegDialog" class="rew19_btn_T1 size_normal" onclick="return false;">자동이체 계좌 관리</a>
        </dt>
        <dd
          class="rew19_infoStar"
        >자동이체 계좌 변경을 하실 경우, 변경까지 영업일 기준 최대 3일정도 소요 되며, 신규 신청은 계좌 등록 완료된 이후 부터 가능 합니다.</dd>
      </dl>
    </div>
    <!--rew19_visible_bBook-->

    <bank-account-reg-dialog
      :show="bankAccountRegDialogShow"
      @close="bankAccountRegDialogClose"
      ref="bankAccountRegDialog"
    ></bank-account-reg-dialog>
  </div>
</template>
<script>
import * as ErrMsg from "@/utils/error_msg";
import * as Common from "@/utils/common";
import BankAccountRegDialog from '@/components/popup/BankAccountRegDialog';
import AroBase from '@/components/base/AroBase';

const INIT_VIEW_DATA = {
  card :{
    birth : null,
    cardNums : [null, null, null, null],
    expMM : null,
    expYY : null,
    pwd : null,
    instMonth : "00",
    isCheckCard : false,
  },
  account:{
    // bank_account: "4280***************"
    // bank_account_holder: "이길준"
    // bank_code: "20"
    // bank_name: "우리은행"
    // birth: "810810"
    // cms_no: "1000046107"
    // cms_status: "1"
    // cms_typ: "A"
    // member_id: "KR0000001",
    bank_account: null,
    bank_account_holder: null,
    bank_code: null,
    bank_name: "-",
    birth: null,
    cms_no: null,
    cms_status: "0",
    cms_typ: "D",
    receipt_no: "",
  }
}

export default {
  name: "PaymentMethod",
  extends: AroBase,
  components: {
      BankAccountRegDialog
  },
  props: {
    paymentMode: {
      type: Number,
      default : 0 // 0:신용카드/계좌 자동이체, 2:신용카드만, 3:계좌 자동이체만
    },
    mode: {
      type: String,
      default: ""
    },
    isHidden: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paymentType : 2, //2:신용카드, 3:계좌 자동이체,
      currentZIndex : 2000,

      viewData : {
        ...INIT_VIEW_DATA
      },

      rawCms : {},

      //자동이제 계좌 등록/변경
      bankAccountRegDialogShow : false,
      bankAccountRegDialog : {},
    }
  },
  mounted() {
    let _this = this;

    switch(_this.paymentMode){
    case 0:
    case 2:
      _this.paymentType = 2;
      break;
    case 3:
      _this.paymentType = 3;
      break;
    }

  },
  methods: {
    updateVisibility(hidden) {
      this.isHidden = hidden; // 부모에서 전달받은 상태로 변경
    },
    //부모 호출용
    initData(data){
      let _this = this;

      _this.viewData ={
        ...INIT_VIEW_DATA
      };

      _this.paymentType = data.paymentType;
      if(_this.paymentType == 2){
        _this.viewData.card = {
          ..._this.viewData.card,
          ...data.card
        };

        let cardNums = data.card && data.card.cardnumber ?
          Common.getArrayForCardNumber(data.card.cardnumber) : [null, null, null, null];
        _this.viewData.card.cardNums = [...cardNums];
      }else if(_this.paymentType == 3){
        _this.loadCms();
      }
    },
    //결제정보 가져오기
    getPaymentInfo(){
      return null; //TODO : data return
    },

    getData() {
      let _this = this;

      if(_this.paymentType == 2){
        return {
          paymentType : _this.paymentType,
          card : _this.viewData.card
        };
      }else{
        return {
          paymentType : _this.paymentType,
          account : _this.viewData.account
        };
      }
    },

    //카드 유효성 검사
    reqCheckCard(){
      let _this = this;

      return new Promise(function (resolve, reject) {
        let card = _this.viewData.card;
        GibberishAES.size(128);
        let cardInfo = {
          ccard_no : GibberishAES.aesEncrypt(card.cardnumber, _this.$getMemberIdKey()),
          ccard_exp : GibberishAES.aesEncrypt(card.expYY + card.expMM,_this.$getMemberIdKey()),
          birth_dt : card.birth,
          passwd : card.pwd
        };

        // cardInfo = _this.processEncodeOrNot(cardInfo, _this.viewData);

        _this.viewData.card.isCheckCard = false;

        _this.$showLoading();
        _this.apiCheckCardValidate(cardInfo).then(res=>{

          if (res.status === 200 && res.data.status === "0000") {
            _this.viewData.card.isCheckCard = true;
          }else{
            _this.viewData.card.isCheckCard = false;
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
          }

          resolve(_this.viewData.card.isCheckCard);

        }).catch((err)=>{

          console.error(err);

          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

          reject(false);

        }).finally(()=>{
          //hide loading
          _this.$hideLoading();
        });
      });
    },

    //입력정보 검증
    validateInfo() {
      let _this = this;

      if(_this.paymentType == 2){
        return _this.validateCard();
      }else{
        return _this.validateAccount();
      }
    },

    /**
     * API Request
     */
    //CMS 정보 가져오기
    apiGetCms(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_cms`, {
        params: {
          //memberId : memberId
        }
      });
    },

    //카드 유효성 검사
    /**
     * cardInfo : {
     *  카드번호 : ccard_no[1111222233334444]
     *  카드유효기간 : ccard_exp[년/월(1904)]
     *  생년월일 : birth_dt[880101]
     *  비밀번호(앞2자리) : passwd[11]"
     * }
     */
    apiCheckCardValidate(cardInfo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/check_card_validate`, {
        params: {
          card_list : JSON.stringify([cardInfo])
        }
      });
    },

    loadCms(){
      let _this = this;

      _this.$showLoading();
      _this.apiGetCms().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.viewData.account = {
            ..._this.viewData.account,
            ...res.data,
            birth : "",
          }

          _this.rawCms = {
            ...res.data
          };

          _this.$emit('setTerms', true, _this.paymentType);
        }else{
          //console.error(res);
        }
      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    numberKeyPress(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    keyUpToNumber(evt, nextRef){
      let _this = this;
      evt = (evt) ? evt : window.event;
      evt.target.value = evt.target.value.replace(/[^0-9]/g, "");

      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if(charCode == 46 || charCode == 8){
        evt.target.value = '';
      }

      if(nextRef){
        let maxLength = evt.target.maxLength;
        if(evt.target.value.length >= maxLength){
          _this.$refs[nextRef].focus();
        }
      }
    },

    keyDown(evt, target){
      let _this = this;
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if(charCode == 46 || charCode == 8){
        evt.target.value = '';
        _this.viewData.card.cardNums[target] = '';
      }
    },

    //카드 결제 정보 검증
    validateCard(){
      let _this = this;

      let cardInfo = _this.viewData.card;
      let rexExOnlyNum = /^[0-9]*$/;
      let chVal = "";

      //생년월일
      chVal = cardInfo.birth;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("생년월일을 입력해 주십시오.")
        .then(res => {
          _this.$refs.birth.focus();
        });
        return false;
      }

      let regExBirth = /^\d{2}(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;
      if(!regExBirth.test(chVal)){
        _this.$dialogs.alert("생년월일 6자리 숫자로 입력해 주십시오.")
        .then(res => {
          _this.$refs.birth.focus();
        });
        return false;
      }

      //카드확인
      let errMsgCardNum = [
        "카드번호 첫번째자리 입력하시기 바랍니다.",
        "카드번호 두번째자리 입력하시기 바랍니다.",
        "카드번호 세번째자리 입력하시기 바랍니다.",
        "카드번호 네번째자리 입력하시기 바랍니다.",
      ];

      let errMsgCardNumNumber = [
        "카드번호 첫번째자리 숫자만 입력하시기 바랍니다.",
        "카드번호 두번째자리 숫자만 입력하시기 바랍니다.",
        "카드번호 세번째자리 숫자만 입력하시기 바랍니다.",
        "카드번호 네번째자리 숫자만 입력하시기 바랍니다."
      ];

      let cardnumber = "";
      for (let idx=0; idx < cardInfo.cardNums.length; idx++){
        let cardNum = cardInfo.cardNums[idx];

        if(!cardNum || cardNum.trim() == ""){
          _this.$dialogs.alert(errMsgCardNum[idx])
          .then(res => {
             _this.$refs["cardNum"+(idx+1)].focus();

          });
          return false;
        }

        if(!rexExOnlyNum.test(cardNum)){
          _this.$dialogs.alert(errMsgCardNumNumber[idx])
          .then(res => {
            _this.$refs["cardNum"+(idx+1)].focus();
          });
          return false;
        }

        cardnumber += (""+cardNum);
      }

      if(cardnumber.length < 14){
        _this.$dialogs.alert("카드번호 14자리 이상 입력하시기 바랍니다.")
        .then(res => {
          _this.$refs["cardNum1"].focus();
        });
        return false;
      }
      cardInfo.cardnumber = cardnumber;

      //유효기간 MM
      chVal = cardInfo.expMM;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("카드 유효기간 월을 입력해 주세요.")
        .then(res => {
          _this.$refs.expMM.focus();
        });
        return false;
      }

      if(!rexExOnlyNum.test(chVal)){
        _this.$dialogs.alert("카드 유효기간 월을 숫자로만 입력하시기 바랍니다.")
        .then(res => {
          _this.$refs.expMM.focus();
        });
        return false;
      }

      //유효기간 YY
      chVal = cardInfo.expYY;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("카드 유효기간 년도를 선택해 주세요.")
        .then(res => {
          _this.$refs.expYY.focus();
        });
        return false;
      }

      if(!rexExOnlyNum.test(chVal)){
        _this.$dialogs.alert("카드 유효기간 년도를 숫자로만 입력하시기 바랍니다.")
        .then(res => {
          _this.$refs.expYY.focus();
        });
        return false;
      }

      //비밀번호 2자리
      chVal = cardInfo.pwd;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("카드 비밀번호를 입력하시기 바랍니다.")
        .then(res => {
          _this.$refs.pwd.focus();
        });
        return false;
      }

      if(chVal.length != 2){
        _this.$dialogs.alert("카드 비밀번호 숫자를 2자리 입력해주시기 바랍니다.")
        .then(res => {
          _this.$refs.pwd.focus();
        });
        return false;
      }

      if(!rexExOnlyNum.test(chVal)){
        _this.$dialogs.alert("카드 비밀번호 숫자만 입력하시기 바랍니다.")
        .then(res => {
          _this.$refs.pwd.focus();
        });
        return false;
      }

      return true;

    },

    //계좌이체 정보 검증
    validateAccount(){
      let _this = this;
      let accountInfo = _this.viewData.account;
      let chVal = "";

      if(accountInfo.cms_status != "1"){
        _this.$dialogs.alert("등록된 계좌정보가 존재하지 않습니다.")
        .then(res => {});
        return false;
      }

      if(accountInfo.cms_typ != "A"){
        _this.$dialogs.alert("등록 완료된 계좌정보가 존재하지 않습니다.")
        .then(res => {});
        return false;
      }

      //생년월일
      chVal = accountInfo.birth;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("생년월일 입력해 주십시오.")
        .then(res => {
          _this.$refs["account.birth"].focus();
        });
        return false;
      }

      let regExBirth = /^\d{2}(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;
      if(!regExBirth.test(chVal)){
        _this.$dialogs.alert("생년월일 6자리 숫자로 입력해 주십시오.")
        .then(res => {
          _this.$refs["account.birth"].focus();
        });
        return false;
      }

      //현금영수증 번호
      chVal = accountInfo.receipt_no;
      let regExMobile = /^(?:(010-?\d{4})|(01[1|6|7|8|9]-?\d{3,4}))-?\d{4}$/;
      if(!regExMobile.test(chVal)){
        _this.$dialogs.alert("휴대폰 번호를 확인해 주십시오.")
        .then(res => {
          _this.$refs["account.receipt_no"].focus();
        });
        return false;
      }


      return true;
    },

    //Open Dialog 계좌 등록
    openBackAccountRegDialog(){
      let _this = this;

      _this.$refs.bankAccountRegDialog.initData({
        isExistCms : _this.rawCms.cms_no != ""
      });
      _this.bankAccountRegDialogShow = true;
    },

    //계좌 등록 신청 후 처리
    bankAccountRegDialogClose(isOk, data){
       let _this = this;

      _this.bankAccountRegDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      _this.loadCms();
    },
    showTerms(){
      let _this = this;
      _this.$emit('setTerms', true, "2");
    },

  }
}
</script>
<style>
.rew19_payment_oc, .rew19_paymentDon, .rew19_visible_credit, .rew19_visible_card, .rew19_visible_bBook { display: inherit; }
</style>



// WEBPACK FOOTER //
// src/components/payment/PaymentMethod.vue